export default __webpack_public_path__ + "static/event-conferences-video-thumbnail-c7d95f61bda8b8fcfa577db06da050d8.png";